import { load } from '@shopify/theme-sections';
import { runIndexHeroInit } from './index-hero/index-hero';
import { initReviewsSlider } from './index-reviews/index-reviews';
import CarriageTabs from '../../scripts/components/CarriageTabs';
import SlidesToggle from '../../scripts/components/SlidesToggle';
import { initPromoBannerHero } from '../common/promo-banner-hero/promo-banner-hero';
import { activateSmartApartmentTab } from '../../snippets/smart-apartment/smart-apartment';
import { initVideoAutoplayControls } from '../../scripts/utils/videoAutoplayControls/videoAutoplayControls';

initPromoBannerHero();

const { runSliderAutoplay } = runIndexHeroInit();

window.addEventListener('load', () => {
  runSliderAutoplay();
});

initVideoAutoplayControls();
initReviewsSlider();

load('*');

window.onReady(() => {
  activateSmartApartmentTab();
  SlidesToggle.init(
    document.querySelector('[data-smart-apartment-arrows]'),
    '8'
  );
  CarriageTabs.init(
    document.querySelector('[data-smart-apartment-tabs-panel]')
  );
});
